export default __webpack_public_path__ + "static/media/leftGifImg.93f9e1a8.png";